<template>

  <el-dialog title="라이센스" 
    :visible.sync="value" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :show-close="false"
    @open="dialogOpen">
    <el-form :model="form" ref="form" :label-width="'120px'">

      <el-form-item label="기간">
        <el-date-picker
          v-model="date_range"
          type="daterange"
          start-placeholder="시작일"
          end-placeholder="종료일">
        </el-date-picker>
      </el-form-item>

      <el-form-item 
        label="라이센스 타입" 
        prop="type"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-select v-model="form.type" placeholder="타입을 선택해 주세요" :disabled="disable_type">
          <el-option 
            v-for="type in $service.licenseType" 
            :key="type.value"
            :label="type.name"
            :value="type.value"
            :disabled="type.disabled">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item 
        label="결제타입" 
        prop="payment_method"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-select v-model="form.payment_method" placeholder="타입을 선택해 주세요">
          <el-option 
            v-for="type in $service.paymentMethods" 
            :key="type.value"
            :label="type.name"
            :value="type.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item 
        label="디바이스" 
        prop="device_vol"
        :rules="[
          { required: true, message: '필수 항목 입니다.'},
          { type: 'number', message: '숫자만 입력 가능합니다.'}
        ]">
        <el-input v-model.number="form.device_vol" autocomplete="off" :disabled="disable_device_vol"></el-input>
      </el-form-item>

      <el-form-item 
        label="결제 금액" 
        prop="price"
        :rules="[
          { required: true, message: '필수 항목 입니다.'},
          { type: 'number', message: '숫자만 입력 가능합니다.'}
        ]">
        <el-input v-model.number="form.price" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">취소</el-button>
      <el-button type="primary" @click="submitForm">확인</el-button>
    </span>
  </el-dialog>

</template>

<script>
import _ from 'lodash'
export default {
  props: ['value', 'license'],
  methods: {
    async dialogOpen () {
      if (_.isObject(this.license)) {
        this.form.start_date = this.$service.moment().isAfter(this.license.expire_date)
          ? this.$service.moment().toISOString()
          : this.$service.moment(this.license.expire_date).add(1, 'day').toISOString()

        this.form.expire_date = this.$service.moment(this.form.start_date).add(1, 'month').toISOString()
        this.form.type = this.license.type
        this.form.payment_method = this.license.payment_method
        this.form.period = this.license.period
        this.form.price = this.license.price
        this.form.device_vol = this.license.device_vol
        this.form.company_fk = this.license.company_fk
        this.form.license_ref = this.license.license_ref || this.license.pk
        if (this.license.type === 'Free') {
          this.disable_type = false
          this.disable_device_vol = false
          this.form.type = 'Basic'
        }
        else {
          this.disable_type = true
          this.disable_device_vol = true
        }
      }
      else if (_.isString(this.license)) {
        this.form.start_date = this.$service.moment().toISOString()
        this.form.expire_date = this.$service.moment().add(1, 'month').toISOString()
        this.form.type = this.license
        this.form.license_ref = null
        this.form.device_vol = 5

        this.disable_type = this.license !== 'Free'
        this.disable_device_vol = false
      }
      this.date_range = [this.form.start_date, this.form.expire_date]
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = _.clone(this.form)

          params.start_date = this.date_range[0]
          params.expire_date = this.date_range[1]

          this.$emit('close', params)
          this.$refs.form.resetFields()
        }
      });
    },
    close () {
      this.$emit('close')
      this.$refs.form.resetFields()
    }
  },
  data () {
    return {
      form: {
        start_date: '',
        expire_date: '',
        type: '',
        payment_method: null,
        period: null,
        price: null,
        device_vol: null,
        company_fk: null,
        license_ref: null
      },
      date_range: [],
      disable_type: false,
      disable_device_vol: false
    }
  }
}
</script>
